var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_317_8125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8583 8.7124C47.7541 11.3999 48.2458 14.2749 48.2458 17.2624C48.2458 26.9666 42.9 35.3791 35.2083 40.1374C35.1208 40.1916 35.0333 40.2499 34.9458 40.2999C34.9166 40.3166 34.8875 40.3374 34.8583 40.3541C32.5541 41.7124 29.8708 42.4957 27.0041 42.4957C18.45 42.4957 11.5125 35.5582 11.5125 27.0041C11.5125 21.6666 14.2125 16.9582 18.3208 14.1749C11.1416 18.5582 5.7583 27.3916 5.7583 36.7416C5.7583 39.7332 6.25413 42.6124 7.15413 45.2999C12.0875 50.6499 19.1541 54.0041 27.0041 54.0041C41.9166 54.0041 54.0041 41.9166 54.0041 27.0041C54.0041 19.9457 51.2958 13.5249 46.8625 8.71657L46.8583 8.7124Z",
    fill: "url(#paint0_linear_317_8125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3167 14.1708C20.7917 12.4917 23.7833 11.5083 27 11.5083C35.5542 11.5083 42.4917 18.4458 42.4917 27C42.4917 32.5375 39.5833 37.3958 35.2083 40.1333C42.9 35.375 48.2458 26.9625 48.2458 17.2583C48.2458 14.2667 47.7542 11.3958 46.8583 8.70833C41.925 3.35833 34.8542 0 27 0C12.0875 0 0 12.0875 0 27C0 34.0625 2.7125 40.4875 7.15 45.2958C6.25 42.6042 5.75417 39.7292 5.75417 36.7375C5.75417 27.3833 11.1375 18.5542 18.3167 14.1708Z",
    fill: "url(#paint1_linear_317_8125)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_317_8125",
    x1: 6.11302,
    y1: 44.8301,
    x2: 50.4317,
    y2: 17.3173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106093,
    stopColor: "#007D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402219,
    stopColor: "#20C997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697538,
    stopColor: "#007D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953216,
    stopColor: "#20C997"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_317_8125",
    x1: 0.354714,
    y1: 36.121,
    x2: 44.6757,
    y2: 8.60935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106093,
    stopColor: "#007D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402219,
    stopColor: "#20C997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697538,
    stopColor: "#007D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953216,
    stopColor: "#20C997"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_317_8125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.6c905a6d212844a0d9f6168b09071b2a.svg";
export { ForwardRef as ReactComponent };